export const TAX_REPORT_DATA = "TAX_REPORT_DATA";
export const TAX_SUMMARIZE = "TAX_SUMMARIZE";
